export default __webpack_public_path__ + "static/3cutouts-c5f03e6d5b38be470510187ee6ddad3f.png";